import { DropdownButton, MenuItem } from 'react-bootstrap';
import { IRecipient } from '@nkr/models/index';
import OverlayMenuButton from '@nkr/components/overlay-menu-button';
import { RecipientAction } from './recipient-action';

const menuItemList = [
    { action: RecipientAction.ViewMedicalDetails, title: <>View Details</> },
    { action: RecipientAction.Edit, title: <>Edit</> },
    { action: -1, title: '' }
];

interface IProps {
    centerId: number,
    recipient: IRecipient,
    showLinkToDetails: boolean,
    showBsMenu: boolean,
    showOption: boolean,
    onMenuDisplayed?: (id: number) => void,
    onMenuToggle: (show: boolean) => void,
    onItemSelected: (id: number, action: number) => void
}

const ActionsDropdown = (props: IProps) => {
    const handleMenuToggle = (show: boolean) => {
        props.onMenuToggle(show);
    };

    const handleMenuSelection = (id: any, action: number) => {
        props.onItemSelected(id, action);
    };

    const getUrl = (action: RecipientAction) => {

        let { recipient, centerId } = props;
        let { id: id } = recipient;

        switch (action) {
            case RecipientAction.Edit: return { link: '/center/' + centerId + '/recipient/' + id + '/profile/general', target: '_blank' };
        }
    };

    const getMenuItems = () => {
        let menuItems: RecipientAction[] = [];

        menuItems.push(RecipientAction.ViewMedicalDetails);

        menuItems.push(RecipientAction.Edit);

        menuItems.push(-1);

        return menuItems;
    };

    const renderBsStyle = () => {
        const { centerId } = props;
        const id = props.recipient != null ? props.recipient.id : 0;

        return (
            <DropdownButton id={`action-menu-${id}`} bsStyle='primary' bsSize='medium' title="Actions" style={{ width: '200%' }} block>
                <MenuItem href={'/center/' + centerId + '/recipient/' + id + '/profile/general'}>
                    Edit
                </MenuItem>
            </DropdownButton>
        );
    }

    if (props.showBsMenu) {
        return renderBsStyle();
    }

    const menuItems = getMenuItems().map(item => {
        return menuItemList.find(x => x.action == item);
    });

    const menu = menuItems.map(item => {
        let url = item.action != -1 ? getUrl(item.action) : null;
        let id = item.action >= 0 ? props.recipient.id : 'div-' + props.recipient.id + '-' + Math.random() * 10000;

        if (url == null) {
            if (item.action >= 0) {
                return { id, action: item.action, include: true, selectable: true, element: <>{item.title}</> };
            } else {
                return { id, action: item.action, include: true, selectable: false, divider: true, element: null };
            }
        } else {
            return { id, action: item.action, include: true, selectable: false, element: <a href={url.link} target={url.target}>{item.title}</a> };
        }
    });

    return (
        <OverlayMenuButton
            menu={menu}
            bsStyle='primary'
            bsSize='xs'
            title='Actions'
            listItemStyle={{ padding: '2px 10px', fontSize: 14 }}
            includeCaret={true}
            onToggle={handleMenuToggle}
            onSelect={handleMenuSelection}
        />
    );
}

export default ActionsDropdown;